import { useState, useEffect } from "react";
import Checkbox from "../checkbox";

export default function CheckBox({ value, onChange, params }) {
  const [_value, setValue] = useState(false);

  useEffect(() => {
    if (typeof value !== undefined) {
      setValue(value);
    } else {
      onChange(params.true ? params.true : true);
    }
  }, [value]);

  const handleChange = (v) => {
    if (params["" + v]) {
      setValue(params["" + v]);
      onChange(params["" + v]);
    } else {
      setValue(v);
      onChange(v);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <Checkbox
        style={{ fontSize: 20, color: "#333" }}
        checked={params.true ? _value === params.true : _value}
        onChange={handleChange}
      />
    </div>
  );
}
